import { InjectionToken } from '@angular/core';

import { RoleModuleConfiguration } from '.';

export const RoleConfigurationService = new InjectionToken<RoleModuleConfiguration>('RoleModuleConfiguration');
